import * as React from 'react';

import { mergeStyles } from '@cian/utils/lib/shared/style';

import * as styles from './contacts_field.css';
import { Input, MaskedInput, Tooltip } from '@cian/ui-kit';

interface IContactsFieldProps {
  isValid: boolean;
  className: string;
  phoneValue: string;
  emailValue: string;
  phoneChange(value: string): void;
  emailChange(e: React.ChangeEvent<HTMLInputElement>, value: string): void;
}

const ContactsField = (props: IContactsFieldProps) => (
  <div {...mergeStyles(props.className, styles['contacts'])}>
    <div className={styles['phone_container']}>
      +7&nbsp;
      <MaskedInput
        mask="000 000-00-00"
        placeholder="000 000-00-00"
        invalid={!props.isValid}
        width="140px"
        value={props.phoneValue}
        onChange={props.phoneChange}
      />
    </div>
    <span>и/или</span>
    {!props.isValid && (
      <div className={styles['tooltip_container']}>
        <Tooltip title="Укажите контакты" placement="right">
          <div className={styles['tooltip_inner']}>&nbsp;</div>
        </Tooltip>
      </div>
    )}
    <div className={styles['email_container']}>
      <Input
        invalid={!props.isValid}
        width="288px"
        value={props.emailValue}
        placeholder="email"
        onChange={props.emailChange}
      />
    </div>
  </div>
);

export { ContactsField };
